import { FETCH_PRODUCTS, SET_GRADE, SET_EMAIL, SET_OFFER_DATA, SET_VARIANT, SET_SETTINGS, SET_SHOW_GRADE_SELECTION_POPUP, SET_SHOW_MORE_PLANS, SET_PRODUCTS, SET_PROMO_CODE, SET_COUPONS } from "../actions/actionType";

export const initialState = {
  products: [],
  grade: null,
  email: "",
  settings: {
    preferred_language: "en"
  },
  coupons: [],
  offerLoaded: false,
  variant: "1",
  showGradeSelectionPopup: false,
  showMorePlans: false,
  promoCode: '',
}

export const SemReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return {
        ...state,
        products: action.payload
      }

    case SET_GRADE: 
      return {
        ...state,
        grade: action.payload
      }

    case SET_EMAIL:
      return {
        ...state,
        email: action.payload
      }
    
    case SET_OFFER_DATA:
      return {
        ...state,
        settings: { ...state.settings, ...action.payload.properties },
        offerLoaded: true
      }

    case SET_VARIANT:
      return {
        ...state,
        variant: action.payload
      }

    case SET_SETTINGS:{
      return {
        ...state,
        settings: { ...state.settings, ...action.payload }
      };
    }

    case SET_SHOW_GRADE_SELECTION_POPUP: {
      return {
        ...state,
        showGradeSelectionPopup: action.payload
      }
    }

    case SET_SHOW_MORE_PLANS : {
      return {
        ...state,
        showMorePlans: action.payload
      }
    }

    case SET_PRODUCTS : {
      return {
        ...state,
        products: action.payload
      }
    }

    case SET_PROMO_CODE : {
      return {
        ...state,
        promoCode: action.payload
      }
    }

    case SET_COUPONS: {
      return {
        ...state,
        coupons: action.payload
      }
    }

    default:
      return state
  }
}